/*
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2025-07-31 19:41:43
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-07-31 20:00:22
 * @FilePath: /widverse-v2/src/pages/Picks/bl-shop.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { Picks } from "@/constants/picks"
import { Result } from "antd"
import { useMemo } from "react"
import { useParams } from "react-router-dom"
export default function BilibiliShop() {
  const { id } = useParams()

  const item = useMemo(() => {
    return Picks.find(_item => _item.id === Number(id))
  }, [id])

  const ErrorLink = () => <Result
    status="error"
    title="模版链接无效"
    subTitle="请检查是否为链接复制不完整，还是有问题请联系平台客服！！！！！"
  ></Result>

    return <>{id ? <div>{item?.title}</div>:<ErrorLink />}</>
}